module.exports = __webpack_public_path__ + "static/media/IconMenu.0b78bd91.svg";